import { ActionReducerMap } from '@ngrx/store';
import { DialogsState } from './dialogs.state';
import { deleteAnnouncementDialogReducers } from '../delete-announcement-dialog/+store/delete-announcement-dialog.reducers';
import { infoPopupDialogReducers } from '../info-popup-dialog/+store/info-popup-dialog.reducers';
import { changeCredentialsDialogReducers } from '../change-credentials-dialog/+store/change-credentials-dialog.reducers';
import { analyticsConsentDialogReducers } from '../analytics-consent-dialog/+store/analytics-consent-dialog.reducers';
import { logoutDialogReducers } from '../logout-dialog/+store/logout-dialog.reducers';
import { timeDeviationDialogReducers } from '../time-deviation-dialog/+store/time-deviation-dialog.reducers';
import { appChooserDialogReducers } from '../app-chooser-dialog/+store/app-chooser-dialog.reducers';

/**
 * Kombinierte Reducers für alle Dialoge.
 */
export const dialogsReducers: ActionReducerMap<DialogsState> = {
  deleteAnnouncementDialog: deleteAnnouncementDialogReducers,
  infoPopupDialog: infoPopupDialogReducers,
  changeCredentialsDialog: changeCredentialsDialogReducers,
  analyticsConsentDialog: analyticsConsentDialogReducers,
  logoutDialog: logoutDialogReducers,
  timeDeviationDialog: timeDeviationDialogReducers,
  appChooserDialog: appChooserDialogReducers,
};
